let domain = window.location.host
let prefix = domain.match(/localhost:/) ? "ws://" : "wss://";

domain = prefix + domain + "/cable";

import { createConsumer } from '@rails/actioncable';
const consumer = createConsumer(domain);

export default consumer;
